import React, {  useEffect, useState } from 'react';
import {FormLabel} from 'react-bootstrap';
import CigHeader from '../../components/CigHeader';
import {base64ToJson, getCookie, sendRedirectWithForm} from '../../common/utils';
import {getUserProfile} from '../../actions';
import { connect } from 'react-redux'
import {CIG_SSO, GATEWAY_REDIRECT_ID, GATEWAY_TENANT_ID} from '../../common/constants';
import * as _ from 'lodash';


export const propfileCache = {
    expiresTimeCache: 0
};

function Profile({ auth, getUserProfile }) {
    const [ profileData, setProfileData ] = useState({
        profile: {},
        idToken: '',
        accessToken: '',
    });

    const areaStyle = 'tw-m-16px tw-border tw-border-solid tw-border-gray-300 tw-p-5px tw-w-full tw-h-160px tw-resize-none tw-text-med';

    const loadUserData = () => {
        getUserProfile(auth, (err, profile) => {
            if (err) {
                setProfileData({
                    ...profileData,
                    profile: {},
                    idToken: '',
                    accessToken: '',
                });
            }
            else {
                setProfileData({
                    ...profileData,
                    profile: profile || {},
                    idToken: '',
                    accessToken: (profile.sessionId ? profile.sessionId : auth.getAccessToken()) || ''
                });
            }
        }, false);
    };

    const monitor = () => {
        const cigck = getCookie('', CIG_SSO.contextCookie);
        if (_.isEmpty(cigck)) {
            window.history.replaceState({cighs: 'abc'}, null, window.location.href);
            window.CIG_LOG.info('Gateway: session expired.');
            sendRedirectWithForm('/ui/logout', GATEWAY_TENANT_ID, window.location.host, GATEWAY_REDIRECT_ID);
        }
        else {
            const contextJson = base64ToJson(cigck);
            if (!_.isEmpty(contextJson) && !_.isNil(contextJson.expiresTime)) {
                const expiresTime = contextJson.expiresTime;
                try {
                    if (_.isNumber(expiresTime)) {
                        if (expiresTime !== propfileCache.expiresTimeCache) {
                            propfileCache.expiresTimeCache = expiresTime;
                        }
                        else {
                            const currentTime = Date.now();
                            window.CIG_LOG.debug('Refresh in seconds............' + (propfileCache.expiresTimeCache - currentTime));
                            if ((propfileCache.expiresTimeCache - currentTime) < 0) {
                                window.history.replaceState({cighs: 'abc'}, null, window.location.href);
                                window.CIG_LOG.info('Gateway: session expired. ExpirationTime: ' + expiresTime + ' Current Time: ' + Date.now());
                                sendRedirectWithForm('/ui/logout', GATEWAY_TENANT_ID, window.location.host, GATEWAY_REDIRECT_ID);
                            }
                        }
                    }
                    else {
                        window.CIG_LOG.warn('Profile: Not a number..............');
                    }
                }
                catch (e) {
                    //Do nothing.
                    window.CIG_LOG.error('Profile: Exception ..........');
                }
            }
        }
    }

    useEffect(() => {
        loadUserData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!_.isEmpty(profileData.profile)) {
            setInterval(monitor, 5000);
        }
    }, [profileData]);

    // eslint-disable-next-line
    const showEnterprisePage = () => {
        const username = <h3>User name: {profileData.profile.name}</h3>
        return (
            <div className='tw-p-56px tw-text-16px'>
                <h2 className='tw-text-xl'>Tokens</h2>
                <div className='tw-pt-16px tw-pl-16px tw-pr-38px'>
                    <li>Access Token:</li>
                    <textarea id="accessToken" className={areaStyle} value={profileData.accessToken} readOnly></textarea>
                </div>
                <h2 className='tw-text-xl tw-pt-18px'>Identity</h2>
                <div className='tw-p-16px tw-mt-20px tw-border-2px'>
                    <FormLabel header={username}>
                        <pre className='tw-text-med'>{JSON.stringify(profileData.profile, null, 2)}</pre>
                    </FormLabel>
                </div>
            </div>
        );
    }

    const showPage = () => {
        if (_.isEmpty(profileData.profile)) {
            return (<div id='profile-empty-container'></div>);
        }
        return (
            <div id='profile-container'>
                <CigHeader/>
                {
                    showEnterprisePage()
                }
            </div>
        )
    }

    return (
        <div>
            {showPage()}
        </div>
    );
}

Profile.displayName = 'Profile';
function mapStateToProps(){
    return {
    }
}

export default connect(
    mapStateToProps,
    {
        getUserProfile,
    }
)(Profile);
